export const PERS_SAVED_SEARCH_FAVORITES_MERGE_EXPERIMENT = 'aud_desktop_bx775_saved_search_favorites_merge';
export const AUD_MOBILE_CLEAN_FIRST_SESSION = 'aud_mobile_bx926_clean_first_session';
export const BX_MOBILE_BX1036_HIDE_POST_BUTTON = 'bx_mobile_bx1036_hide_post_button';

export const EXPERIMENTS = [
  PERS_SAVED_SEARCH_FAVORITES_MERGE_EXPERIMENT,
  AUD_MOBILE_CLEAN_FIRST_SESSION,
  BX_MOBILE_BX1036_HIDE_POST_BUTTON,
];
